const VideosMatch = function() {
    const glomexPlayer = function(glomexId) {
        return '<glomex-player class="embed-responsive-item" data-integration-id="40599z13k6s8fl1f" data-playlist-id="' + glomexId + '"></glomex-player>';
    };
    const youtubePlayer = function(youtubeId, isModal) {
        const parameters = '?' + [
            'cc_lang_pref=el',
            'fs=0',
            'hl=el',
            'modestbranding=1'
        ].join('&');
        let height = '';
        if (Generic.mobile) {
            if (isModal) {
                height = 'height: 200px;';
            } else {
                height = 'height: 192px;';
            }
        } else {
            if (isModal) {
                height = 'height: 450px;';
            } else {
                height = 'height: 277px;';
            }
        }
        return '<iframe style="width:100%; ' + height + '" src="https://www.youtube.com/embed/' + youtubeId + parameters + '" frameborder="0" allowfullscreen></iframe>';
    };
    return {
        init: function() {
            $(document).on('click', '.modal-event-video-open', function() {
                const videoId = $(this).data('name');
                const provider = $(this).data('provider');
                if (provider == 1) {
                    $('.modal-body').html(glomexPlayer(videoId));
                } else if (provider == 2) {
                    $('.modal-body').html(youtubePlayer(videoId, true));
                }
            });
            $('#modal-video').on('hidden.bs.modal', function() {
                $('.modal-body').html('');
            });
            $(document).on('click', '.next-video', function() {
                const videoId = $(this).data('name');
                const matchId = $(this).data('id');
                const provider = $(this).data('provider');

                if (provider == 1) {
                    $('#current-video-' + matchId).html(glomexPlayer(videoId));
                } else if (provider == 2) {
                    $('#current-video-' + matchId).html(youtubePlayer(videoId, false));
                }
            });
        },
    };
}();
